import { useState } from "react";
import endpointOcrApi from "./AxiosOcrApi";

const useOcrAxios = ({ api, method }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [progress, setProgress] = useState(0);

  const reset = () => {
    setData(null);
    setLoading(false);
    setProgress(0)
  };

  const onCall = async ({ data, headers, params }) => {
    setLoading(true);
    try {
      let result;
      if (method === "get")
        result = await endpointOcrApi[method](api, { headers, params });
      else
        result = await endpointOcrApi[method](api, data, {
          headers, params, onUploadProgress: progressEvent => {
            setProgress((progressEvent.loaded / progressEvent.total) * 100)
          }
        });
      setData(result.data);
      setLoading(false)
      return Promise.resolve(result.data);
    } catch (err) {
      setData(err);
      setLoading(false)
      return Promise.reject(err);
    }
  };

  return {
    loading,
    data,
    progress,
    reset,
    onCall,
  };
};

export default useOcrAxios;
